export default __webpack_public_path__ + "static/icon-24-5-0ff53c99a1fff27a6af942725bb24718.png";